<script lang="ts">
	import { onMount } from 'svelte'
	import CircleBackground from './CircleBackground.svelte'
	import PhoneFrame from './PhoneFrame.svelte'
	import { features } from './FeaturesDesktop.svelte'

	let activeIndex = $state(0)
	let slideContainer: HTMLElement = $state()
	let slideRefs: HTMLElement[] = $state([])

	onMount(() => {
		let observer = new IntersectionObserver(
			(entries) => {
				for (let entry of entries) {
					if (entry.isIntersecting && entry.target instanceof HTMLDivElement) {
						activeIndex = slideRefs.indexOf(entry.target)
						break
					}
				}
			},
			{
				root: slideContainer,
				threshold: 0.6,
			},
		)

		slideRefs.forEach((slide) => observer.observe(slide))

		return () => {
			observer.disconnect()
		}
	})
</script>

<div
	bind:this={slideContainer}
	class="-mb-4 flex snap-x snap-mandatory -space-x-4 overflow-x-auto overscroll-x-contain scroll-smooth pb-4 [scrollbar-width:none] sm:-space-x-6 [&::-webkit-scrollbar]:hidden"
>
	{#each features as feature, featureIndex}
		<div bind:this={slideRefs[featureIndex]} class="w-full flex-none snap-center sm:px-6">
			<div class="relative transform overflow-hidden rounded-2xl bg-brand-gray-6 sm:px-5 py-6">
				<div class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
					<CircleBackground color="#FF006E" />
				</div>
				<PhoneFrame class="relative mx-auto w-full max-w-[366px]">
					<feature.screen />
				</PhoneFrame>
				<div class="absolute inset-x-0 bottom-0 bg-brand-gray-6/95 p-6 backdrop-blur sm:p-10">
					<img src={feature.image} alt="" class="h-8 w-8" />
					<h3 class="mt-6 text-sm font-semibold text-white sm:text-lg">
						{feature.title}
					</h3>
					<p class="mt-2 text-sm text-gray-400">
						{feature.description}
					</p>
				</div>
			</div>
		</div>
	{/each}
</div>

<div class="mt-6 flex justify-center gap-3">
	{#each features as _, featureIndex}
		<button
			aria-label={`Feature ${featureIndex + 1}`}
			type="button"
			class={`relative h-0.5 w-4 rounded-full ${
				featureIndex === activeIndex ? 'bg-brand-gray-3' : 'bg-brand-gray-4'
			}`}
			onclick={() =>
				slideRefs[featureIndex].scrollIntoView({ block: 'nearest', inline: 'nearest' })}
		>
			<span class="absolute -inset-x-1.5 -inset-y-3"></span>
		</button>
	{/each}
</div>
